module.exports = __webpack_public_path__ + "assets/images/T-orange-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/T-orange-icon.png
// module id = 393
// module chunks = 1